import classes from "../Register/Register.module.css";
import "./Register.css";
import React from "react";

import { useNavigate } from "react-router-dom";
import UPI from "../../assets/swiftcore_logo.svg";
// import { Field, Form, Formik } from 'formik';
// import { LoginFormInitialValues, LoginFormValidation } from '../../validations/LoginFormValidation';
import TextFieldForm from "../../components/common/textFieldForm";
import { useForm, Controller } from "react-hook-form";
import { errorMessages } from "../../components/utilities/formValidation";
import { Box, Grid, TextField } from "@mui/material";
import { postApiData } from "../../components/utilities/nodeApiServices";
import { apiList } from "../../components/utilities/nodeApiList";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useState } from "react";
import { SET_USER } from "../../constants";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, login } from "../../actions/userActions";
import { useEffect } from "react";
import styled from "styled-components";
import TextFieldFormNew from "../../components/common/textFieldFormNew";
import { Button } from "@mui/base";
import UpdatePassword from "./updatePasswordModal";
import { RemoveRedEye } from "@mui/icons-material";

// import { useForm, Controller } from 'react-hook-form';
import Input from "@mui/material/Input"; // Assuming you're using Material-UI Input
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import headerLogo from "../../assets/headerLogo.png";
import loginBackground from "../../assets/loginBackground.png";
import RegisterContext from "./RegisterContext";
import SweetAlertPopup from "../../components/common/sweetAlertPopup";
import { LoadingButton } from "@mui/lab";
import Loader from "../../components/common/loader";
import { useLanguage } from "../../context/LanguageContext";



const defaultFormData = {
  email: "",
  password: "",
};

const RegisterContainer1 = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [userId, setUserId] = useState("");
  const { otpDisplay, setOtp, custNo, setResponse } = useContext(RegisterContext);
  const [isLoading, setisLoading] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsKeyboardVisible(event.target.checked);
  }

  const { t } = useLanguage();
  function handleSignup() {
    navigate("/auth/login");
  }
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: defaultFormData,
    mode: "onChange",
  });
  const navigate = useNavigate();
  const handlleNavigate = (route) => {
    navigate(route);
  };
  const popupAlert = (message, msgtype, msgicon) => {
    {
      Swal.fire({
        title: msgtype,
        text: message,
        icon: msgicon,
      });
    }
  };

  // useEffect(() => {
  //   if (error) {
  //     popupAlert("Please Enter Valid Credentials", "Error", "error");
  //     dispatch(clearErrors());
  //   }

  //   if (isAuthenticated) {
  //     navigate("/dashboard")
  //   }
  // }, [dispatch, error, navigate, isAuthenticated,popupAlert]);
  // const { dispatch: authDispatch } = useContext(AuthContext);
  // const dispatchSetUser = (payload) => {
  //   authDispatch({ type: SET_USER, payload });
  // };
  // const [passwordInput, setPasswordInput] = useState('password');

  function handleTerms() {
    navigate("/auth/termsconditions");
  }

  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const bankNames = process.env.REACT_APP_FLAVOUR;
  const onSubmit = async (data) => {
    let custNumber = data.custno;

    // Apply special formatting for one specific bank

    console.log("Bank Name from env:", bankNames);
    if (bankNames === "Bhagini") {
      console.log("Bank is Bhagini, processing custNo...");

      // Ensure email is in the expected format: 4 alphabetic + 8 numeric characters
      if (/^[A-Za-z]{4}\d{8}$/.test(data.custno)) {
        const numericPart = data.custno.slice(-8); // Get the last 8 characters (numeric part)
        console.log("Extracted numeric part:", numericPart);

        // Convert to integer to remove leading zeros, then back to string
        custNumber = parseInt(numericPart, 10).toString();
        console.log("Processed custNo:", custNumber);
      } else {
        console.log("Invalid format for custNo");
      }
    }
    setisLoading(true);
    const payload = {
      custNo: custNumber,
      regType: "mobile",
    };
    const response = await postApiData(apiList.REGISTER, payload);
    // console.log("Register Mobile", response);
    if (response?.status == true) {
      setisLoading(false);
      custNo(data?.custno);
      setOtp(true);
      setResponse(response)
      setIsResendEnabled(false);
      setTimerKey(prev => prev + 1);
    } else {
      setisLoading(false);
      SweetAlertPopup(response?.message, "Error", "error");
    }
  };

  const ColorButton1 = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "var(--button-color)",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    fontSize: '15px',
    width: "123px",
    height: "32px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
  }));

  const [valueTab, setValueTab] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const [ToggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    ToggleState === index ? className : "";

  return (
    <>

      {isLoading ? (<Loader loading={true} />) : (<Loader loading={false} />)}

      <div className={classes.mainpagewithback1}>

        <div className={classes.mainfile1}>
          <Box
            className={classes.boxsss} style={{ width: '100%' }}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
          >

            <div className={classes.regwithmobupper}>{t("withCustNo")}
            </div>
            <div className={classes.firsttabinfoRegister} style={{ width: '95%' }}>
              {bankNames === 'Bhagini' ? <Grid item xs={12} sm={8} md={12} style={{ width: '100%' }}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("Card_CustomerNo")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "custno",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        placeholder: t("Card_CustomerNo"),
                        fullWidth: true,
                        inputProps: {
                          style: { textTransform: 'uppercase' },
                          maxLength: 12,// Capitalize letters
                        }
                      }}
                      regExp={/^[0-9A-Za-z]+$/}
                      rules={{
                        required: t("Card_CustomerNoRequired"),
                        pattern: {
                          value: /^[A-Z]{4}[0-9]{8}$/,
                          message: "ID must be 4 uppercase letters followed by 8 digits",
                        },
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>
                : <Grid item xs={12} sm={8} md={12} style={{ width: '100%' }}>
                  <div className={classes.frowdataaff}>
                    <div className={classes.frowtextaff}>
                      {t("Card_CustomerNo")}
                      <sup className={classes.required}>*</sup>
                    </div>
                    <div className={classes.widthtfield}>
                      <TextFieldForm
                        controlerProps={{
                          control: control,
                          name: "custno",
                          rows: 5,
                          maxRows: 10,
                        }}
                        TextFieldProps={{
                          // label: "Branch",
                          placeholder: t("Card_CustomerNo"),
                          //   style: { width: "130%" },
                          fullWidth: true,
                          // inputProps : {maxLength: 10}
                        }}
                        // backgroundColor={true}
                        regExp={/^[0-9]+$/}
                        rules={{
                          required:
                            t("Card_CustomerNoRequired"),
                          // pattern: {
                          //   value: /^[A-Z]{4}[0-9]{8}$/,
                          //   message: "ID must be 4 uppercase letters followed by 8 digits",
                          // },
                        }}
                        required={true}
                      />
                    </div>
                  </div>
                </Grid>}

              <Grid item xs={12} sm={8} md={12} style={{ width: '95%' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={isKeyboardVisible}
                    onChange={handleCheckboxChange}
                  />
                  <span className={classes.termsspanpara}> {t("accept_msg")} <span className={classes.termsspan} onClick={handleTerms}>{t("card_termscondition")}</span> </span>
                </label>
              </Grid>
              <div className={classes.button}>
                <LoadingButton
                  variant="contained"
                  type="submit"
                  disabled={isKeyboardVisible ? false : true}
                  loading={isLoading}
                  sx={{
                    color: "#FFFFFF",
                    // color:'var(--button-color)',
                    // backgroundColor: "#F84B67",
                    // backgroundColor: "#323232",
                    backgroundColor: "var(--button-color)",
                    border: "1px solid #CCC",
                    borderRadius: "8px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    width: "120px",
                    height: "32px",
                    "&:hover": {
                      // background: "#808080",
                      background: "var(--button-hover-color)",
                      color: "white",
                    },
                    '@media (max-width: 568px)': {
                      background: "var(--button-color)",
                      border: "1px solid #CCC",
                      borderRadius: "14px",
                      paddingLeft: "18px",
                      paddingRight: "18px",
                      width: "100%",
                      height: "38px",
                      // margin: "0px 10px 0px 10px"
                    },
                  }}
                >
                  {t("card_registerButton")}
                </LoadingButton>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
};

export default RegisterContainer1;
